import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { adminApi, setAdminToken, getAdminToken } from "../lib/adminApi";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    if (!getAdminToken()) { setLoading(false); return; }
    try {
      const { data } = await adminApi.get("/auth/me");
      setAdmin(data.admin);
    } catch (err) {
      if (err?.response?.status && err.response.status !== 401) {
        console.error("[AdminAuth] /auth/me failed:", err);
      }
      setAdminToken(null);
      setAdmin(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = useCallback(async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    setAdminToken(data.token);
    setAdmin(data.admin);
    return data.admin;
  }, []);

  const logout = useCallback(() => {
    setAdminToken(null);
    setAdmin(null);
  }, []);

  const value = useMemo(
    () => ({ admin, loading, login, logout, refresh: check }),
    [admin, loading, login, logout, check]
  );

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
};

export const useAdminAuth = () => useContext(AdminAuthContext);
